export default {
  items: [
    {
      title: true,
      name: 'menu_title',
      original: 'menu_title',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'menu_dashboard',
      original: 'menu_dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'menu_packages',
      original: 'menu_packages',
      url: '/packages',
      icon: 'icon-basket'
    },
    {
      name: 'menu_invoices',
      original: 'menu_invoices',
      url: '/invoices',
      icon: 'icon-folder',
    },
    {
      name: 'menu_settings',
      original: 'menu_settings',
      url: '/settings',
      icon: 'icon-settings'
    },
    {
      name: 'menu_support',
      original: 'menu_support',
      url: '/support',
      icon: 'icon-question'
    }
  ]
}
